import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesWorkspaceRunnersPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./runners'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesWorkspaceRunnersPageLoadable;
